import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Analytics } from '@/components/Analytics';

export const Route = createRootRoute({
  component: () => (
    <>
      <Analytics />
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
});
